export default "/static/grundrisse/assets/images/previews/2d/massketten.png"